import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Lock from '@material-ui/icons/LockOutlined';
import Tooltip from '@material-ui/core/Tooltip';

// Style
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => ({
  root: {
    marginRight: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    marginBottom: theme.spacing(2),
  },
  card: {
    width: '100%',
    overflow: 'visible',
    padding: `${theme.spacing()}px !important`,
  },
  cardHeaderRoot: {
    padding: `${theme.spacing()}px !important`,
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  action: {
    alignSelf: 'flex-end',
    paddingRight: theme.spacing(),
  },
  cardContentRoot: {
    padding: `0 ${theme.spacing()}px ${theme.spacing()}px ${theme.spacing()}px !important`,
  },
  icon: {
    color: theme.colors.gray1,
  },
});

class CategoryCard extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
  };

  render() {
    const { classes, children } = this.props;

    return (
      <div className={classes.root}>
        <Card className={classes.card}>
          <CardHeader
            classes={{ root: classes.cardHeaderRoot, action: classes.action }}
            title="People"
            action={
              <Tooltip className={classes.align} title="This category cannot be removed.">
                <Lock className={classes.icon} />
              </Tooltip>
            }
          />
          <CardContent
            className={classes.cardContainer}
            classes={{ root: classes.cardContentRoot }}
          >
            {children}
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default withStyles(styles)(CategoryCard);
